import { ComponentBaseConfigModel } from '../component-base-config.model';

export interface EditConfigModel extends ComponentBaseConfigModel {
  closeAfterAddFeature: boolean;
  copyLayerIds?: string[];
}
